document.addEventListener('DOMContentLoaded', function() {
  // Select ALL product forms with this class
  const forms = document.querySelectorAll('form.cvnh');

  forms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // Redirect directly to checkout
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('There was a problem adding the product:', error);
        alert('Sorry, something went wrong. Please try again.');
      });
    });
  });
});